import React, { type ReactNode } from 'react';
import cx from 'classnames';

import styles from './survey-section.module.scss';

export namespace SurveySection {
  export type Props = {
    children: ReactNode;
    className?: string;
    dataTestId?: string;
  };
  export const $: React.FC<Props> = (props: Props) => {
    const { children, className, dataTestId } = props;
    return (
      <div className={cx(styles.surveySection, className)} data-testid={dataTestId}>
        {children}
      </div>
    );
  };
}
